import { AlertTriangleIcon } from "../../icons.js";
import { relativeTime } from "../../../lib/time.js";
import type { WidgetProps } from "../types.js";

type InjuryPayload = {
  bodyRegion?: string;
  side?: string;
  status?: string;
  severityImpact?: string;
  aiSummary?: string;
};

export function InjuriesWidget({ events, onNavigate }: WidgetProps) {
  const injuries = events.filter((e) => e.eventType === "injury");
  const active = injuries.filter((e) => {
    const p = e.payload as unknown as InjuryPayload;
    return !p.status || p.status === "active" || p.status === "healing";
  });
  const latest = active[0] ?? injuries[0];
  const payload = latest?.payload as unknown as InjuryPayload | undefined;

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-2 flex items-center gap-2">
        <AlertTriangleIcon size={16} className="text-orange-500" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Injuries</h2>
        <button onClick={() => onNavigate("injuries")} className="ml-auto text-xs text-(--accent) hover:underline">
          View all
        </button>
      </div>
      {injuries.length === 0 ? (
        <p className="text-sm text-gray-400 dark:text-gray-500">No injuries recorded</p>
      ) : (
        <div className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
          <div className="flex justify-between">
            <span>Active injuries</span>
            <span className={`font-medium ${active.length > 0 ? "text-orange-600 dark:text-orange-400" : "text-gray-900 dark:text-gray-100"}`}>
              {active.length}
            </span>
          </div>
          <div className="flex justify-between">
            <span>Total recorded</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">{injuries.length}</span>
          </div>
          {payload && (
            <div className="border-t border-gray-100 dark:border-gray-800 pt-2 text-xs text-gray-500 dark:text-gray-400">
              {payload.bodyRegion && (
                <p>Most recent: {payload.bodyRegion}{payload.side ? ` (${payload.side})` : ""}</p>
              )}
              {latest && <p>{relativeTime(latest.occurredAt)}</p>}
            </div>
          )}
        </div>
      )}
    </section>
  );
}
